import React from 'react'
import './CTA.css'

function CTA() {
  return (
    <section id="download" className="cta">
      <div className="container">
        <div className="cta-content">
          <h2 className="cta-title">
            Ready to code <span className="gradient-text">all night</span>?
          </h2>
          <p className="cta-description">
            Join developers who are shipping faster with autonomous AI workflows.
            Get started today and let AllNightAI handle the heavy lifting.
          </p>
          <div className="cta-buttons">
            <a href="https://allnightai-website.s3.amazonaws.com/downloads/AllNightAI.dmg" className="btn btn-primary btn-large">
              Download for macOS
            </a>
          </div>
          <div className="cta-platforms">
            <span>Or install CLI:</span>
            <code style={{background: '#1f2937', color: '#10b981', padding: '8px 16px', borderRadius: '6px', fontFamily: 'Monaco, monospace'}}>npm install -g allnightai-cli</code>
          </div>
        </div>
      </div>
    </section>
  )
}

export default CTA
